export class GetUsersMinimalIdentityDataEntity {
    usersIds;
    scopesIds;    
    isProjectLevel;

    constructor(usersIds, scopesIds, isProjectLevel) {
      this.usersIds = usersIds;
      this.scopesIds = scopesIds;      
      this.isProjectLevel = isProjectLevel;
    }
  }
  